/**
 * Created by chengy on 2019/6/28.
 */
export const newsApiMap = {
  //新闻列表
  newsPage:'/news/v2/page',
  //新闻详情
  newsDetail:'/news/v1/news/',
  //公示公告
  noticePage:'/news/v1/gsgg',
  //公示公告列表
  noticeList:'/news/v1/gsggLastOne',
  //公示公告详情
  noticeDetail:'/news/v1/notices/',
  //信息列表
  queryList: 'message/notice/v1/query',
  //未读总条数
  showList: 'message/notice/v1/show',
  //已读
  readList: 'message/notice/v1/read'
}
